// Store finish reasons in tuple to save on bundle size
// Readonly type should enforce that this is not mutated.
export var FINISH_REASON_TAG = 'finishReason';
export var IDLE_TRANSACTION_FINISH_REASONS = ['heartbeatFailed', 'idleTimeout', 'documentHidden'];
//# sourceMappingURL=constants.js.map